//return array of Numbers
export const getColumnValuesWithZero = (data, col) => {
  let value = [];

  data.forEach((dat, index) => {
    let isNumber = false;
    if (Number(dat[col]) === 0 || Number(dat[col])) {
      isNumber = true;
    }

    if (
      Object.keys(dat).length > 0 &&
      dat[col] !== undefined &&
      isNumber &&
      index !== 0
    ) {
      value.push(Number(dat[col]));
    }
  });

  return value;
};
